import React, { useState, useEffect, useMemo } from 'react';
import { formatDonorAmount, parseDonorsCSV } from '../utils/donors';

const Dathalu = () => {
  const [donors, setDonors] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortOrder] = useState('desc'); // 'desc' for highest amount first

  useEffect(() => {
    fetch('/donors.csv')
      .then((res) => res.text())
      .then((text) => {
        const parsed = parseDonorsCSV(text);
        setDonors(parsed);
      })
      .catch((err) => console.error('Failed to load donors.csv', err));
  }, []);

  const filteredAndSortedDonors = useMemo(() => {
    return donors
      .filter((d) => {
        const matchesSearch = 
          d.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
          (d.name_en && d.name_en.toLowerCase().includes(searchTerm.toLowerCase()));
        return matchesSearch;
      })
      .sort((a, b) => {
        const amtA = Number(String(a.amount).replace(/,/g, '')) || 0;
        const amtB = Number(String(b.amount).replace(/,/g, '')) || 0;
        return sortOrder === 'desc' ? amtB - amtA : amtA - amtB;
      });
  }, [donors, searchTerm, sortOrder]);

  return (
    <section className="story-section dathalu-page page-content">
      <article className="story-content">
        <div className="text-overlay-card">
          <div className="overlay-visual-panel">
            <img
              className="overlay-feature-image"
              src="/ramasethu.jpg"
              alt="రామసేతు దృశ్యం"
            />
          </div>
          <div className="overlay-text-content">
            <h2 className="overlay-quote-title">
              దానమే ధర్మానికి మూలం, త్యాగమే మోక్షానికి మార్గం
            </h2>
            <p className="tab-copy">
              మన వామకుంట్ల గ్రామంలో పునర్నిర్మాణం అవుతున్న ఈ సీతారామచంద్రస్వామి ఆలయం కేవలం ఇటుకలు, రాళ్లతో కట్టే కట్టడం కాదు; ఇది మనందరి భక్తి విశ్వాసాల ప్రతిరూపం. వేదాలు "దానేన సర్వం పుణ్యం అవాప్నోతి" (దానం ద్వారానే సకల పుణ్యాలు లభిస్తాయి) అని ఘోషిస్తున్నాయి.
            </p>
            <p className="tab-copy">
              నాడు త్రేతాయుగంలో శ్రీరామచంద్రుడు సేతువును నిర్మిస్తున్నప్పుడు, ఆ వానర సైన్యంతో పాటు ఒక చిన్న ఉడుత తన శక్తి మేరకు ఇసుకను మోసి స్వామి కృపకు పాత్రురాలైంది. నేడు ఈ ఆలయ పునర్నిర్మాణం కూడా ఒక మహత్తరమైన రామకార్యం. ఇందులో పాలుపంచుకోవడం అంటే మన వంశ పరంపరను తరింపజేసుకోవడమే.
            </p>
            <p className="tab-copy gratitude-text">
              రామయ్య ఆశీస్సులు మీపై, మీ కుటుంబంపై సదా ఉండాలని కోరుకుంటూ... ఈ దివ్య నిర్మాణంలో భాగస్వాములైన భక్తజన దాతలకు మా హృదయపూర్వక ధన్యవాదాలు.
            </p>
          </div>
        </div>

        <div className="special-honors-section">
          <h3 className="honors-main-title">దాతల కోసం ప్రత్యేక గౌరవాలు</h3>
          <div className="honor-slabs-container">
            <div className="honor-slab-card">
              <span className="honor-amount-bracket">రూ.11,116/- మరియు అంతకుపైగా...</span>
              <p className="honor-benefit-text">ఆలయంలో శాశ్వతంగా శిలాఫలకం మీద పేరు చెక్కబడును.</p>
            </div>

            <div className="honor-slab-card">
              <span className="honor-amount-bracket">రూ.1,01,116/- మరియు అంతకుపైగా...</span>
              <p className="honor-benefit-text">
                ప్రతి సంవత్సవం శ్రీ రామనవమి సందర్భంగా గోత్రనామాలతో ప్రత్యేక పూజ సాలగ్రామ శిల స్వర్ణ పుష్పార్చన. కళ్యాణమహోత్సవం, సంవత్సరంలో ఒక రోజు ప్రత్యేక పూజ అవకాశం.
              </p>
            </div>

            <div className="honor-slab-card">
              <span className="honor-amount-bracket">రూ.5,01,116/- మరియు అంతకుపైగా...</span>
              <ul className="honor-benefits-list">
                <li>శాశ్వత ట్రస్ట్ బోర్డు సభ్యత్వం</li>
                <li>శ్రీ రామనవమి రోజున ఉదయస్తమాన సేవలో పాల్గొనే అవకాశం.</li>
                <li>సంవత్సరంలో ఒక రోజు ప్రత్యేక పూజ అవకాశం</li>
              </ul>
            </div>
          </div>

          <div className="donation-info-text-container" style={{ marginTop: '3rem', textAlign: 'center' }}>
            <div className="donation-info-text">
              <p>దాతలు సమర్పించదలచిన విరాళములు వస్తురూపంలో గానీ, నగదు రూపంలో గానీ స్వయంగా కమిటీ వారికి అందజేసి, తగిన రసీదు పొందవలసిందిగా మనవి చేయుచున్నాము.</p>
              <div className="contact-highlight">
                <p>సంప్రదించవలసిన వారు : G. హనుమంతు శ్రీనివాసరావు</p>
                <p>ఫోన్ నెంబర్ : 9948988398</p>
              </div>
            </div>
          </div>
        </div>

        <div className="donor-list-container">
          <div className="donor-table-wrapper">
            {filteredAndSortedDonors.length > 0 || searchTerm ? (
              <table className="donor-compact-table">
                <thead>
                  <tr>
                    <th className="col-name">
                      <div className="header-search-container">
                        <span className="header-label">దాత పేరు</span>
                        <div className="header-search-box-wrapper">
                          <svg 
                            className="search-icon-svg" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path 
                              d="M15.7955 15.8111L21 21M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z" 
                              stroke="currentColor" 
                              strokeWidth="2" 
                              strokeLinecap="round" 
                              strokeLinejoin="round"
                            />
                          </svg>
                          <input 
                            type="text" 
                            placeholder="వెతకండి..." 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="table-header-search"
                          />
                        </div>
                      </div>
                    </th>
                    <th className="col-amount text-right">విరాళము</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAndSortedDonors.length > 0 ? (
                    filteredAndSortedDonors.map((donor, idx) => (
                      <tr key={idx} className={`donor-table-row status-${donor.status === 'Viralam samarpinchina' ? 'green' : 'red'}`}>
                        <td>
                          <div className="donor-cell-info">
                            <span className="donor-name-te">{donor.name}</span>
                            {donor.comments && (
                              <span className="donor-comment-tag">{donor.comments}</span>
                            )}
                          </div>
                        </td>
                        <td className="text-right">
                          <span className="donor-amount-cell">₹ {formatDonorAmount(donor.amount)}</span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2" className="no-results-cell">
                        క్షమించండి, మీ వెతుకులాటకు సరిపోలే దాతలు దొరకలేదు.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : (
              <div className="no-results">లోడ్ అవుతోంది...</div>
            )}
          </div>
        </div>
      </article>
    </section>
  );
};

export default Dathalu;
